import { AxiosResponse } from "axios";
import { eventVersionService } from "src/services/eventVersionService/eventVersionService";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ListResponse, PaginatedResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

import { EventReport } from "../../dashboard/devices/types";

export type FetchAllEventsPayload = {
    pageIndex?: number;
    pageSize?: number;
    level?: number;
    workspaceId?: number;
    groupIds?: number[];
    entityId?: string;
    category?: "build" | "device" | "file" | "gateway" | "group" | "license" | "product" | "provisioning" | "user" | "workspace";
    createdFrom?: string;
    createdTo?: string;
    searchTerm?: string;
};
export async function fetchAllEvents(payload?: FetchAllEventsPayload): Promise<ListResponse<EventReport>> {
    try {
        const endpoint = await RouteService.getEventsRoute();
        const response: AxiosResponse<PaginatedResponse<API.EventReport>> = await HttpService.get(endpoint + "events/all", {
            params: {
                PageIndex: payload?.pageIndex,
                PageSize: payload?.pageSize,
                Level: payload?.level,
                WorkspaceId: payload?.workspaceId,
                GroupIds: payload?.groupIds,
                EntityId: payload?.entityId,
                Category: payload?.category,
                CreatedFrom: payload?.createdFrom,
                CreatedTo: payload?.createdTo,
                SearchTerm: payload?.searchTerm,
            },
        });
        return {
            ...response.data,
            list: eventVersionService.normalizeList(response.data.list),
        };
    } catch (error) {
        throw unpackError(error);
    }
}
